import { Flags } from 'flagsmith-nodejs';
import IFlagsmith from 'flagsmith';
import React from 'react';

// sort flags alphabetically to match flag-smith order
export const DefaultFlagsContext = {
  DeleteBillingItems: false,
  EnableContracts: false,
  EnableEmailNotificationsDigest: false,
  EnableFilesNotificationCenter: false,
  EnableNotificationCount: false,
  GoogleLoginForInternalUser: false,
  GoogleLoginForClients: false,
  EnableSendMessageWebhook: false,
};

export type FlagContextType = Record<keyof typeof DefaultFlagsContext, boolean>;

export const getServerFlagsContextValue = (flags: Flags) => ({
  DeleteBillingItems: flags.isFeatureEnabled('delete_billing_items'),
  EnableContracts: flags.isFeatureEnabled('contracts'),
  EnableFilesNotificationCenter: flags.isFeatureEnabled(
    'enable_files_notification_center',
  ),
  EnableNotificationCount: flags.isFeatureEnabled('notification_count_title'),
  GoogleLoginForInternalUser: flags.isFeatureEnabled(
    'google_login_for_internal_user',
  ),
  GoogleLoginForClients: flags.isFeatureEnabled('google_login_for_clients'),
});

export const getClientFlagsContextValue = (flags: typeof IFlagsmith) => ({
  DeleteBillingItems: flags.hasFeature('delete_billing_items'),
  EnableContracts: flags.hasFeature('contracts'),
  EnableFilesNotificationCenter: flags.hasFeature(
    'enable_files_notification_center',
  ),
  EnableNotificationCount: flags.hasFeature('notification_count_title'),
  GoogleLoginForInternalUser: flags.hasFeature(
    'google_login_for_internal_user',
  ),
  GoogleLoginForClients: flags.hasFeature('google_login_for_clients'),
  EnableSendMessageWebhook: flags.hasFeature('sent_message_webhook_opt'),
});

export const FlagsContext = React.createContext(DefaultFlagsContext);
